// Email binding module — owns the /auth/email/* endpoints.
//
// Backend reference (all under global prefix /api, JWT required):
//   POST /auth/email/send-code   body { email }  → { email, expiresInSec }
//   POST /auth/email/verify      body { code }   → { email, emailVerifiedAt }
//
// The backend only writes User.email after a code is verified, so a non-null
// `email` on /auth/me means "bound AND verified" — there is no half-bound state.

import { fetchJson } from './client.js';

/** Request a 6-digit verification code to be emailed to `email`. */
export async function sendEmailCode(email) {
  const r = await fetchJson('/auth/email/send-code', {
    method: 'POST',
    auth: 'always',
    body: { email },
  });
  return r.data; // { email, expiresInSec }
}

/** Submit the code the user received; on success binds the email to the account. */
export async function verifyEmailCode(code) {
  const r = await fetchJson('/auth/email/verify', {
    method: 'POST',
    auth: 'always',
    body: { code },
  });
  return r.data; // { email, emailVerifiedAt }
}

export const email = { sendEmailCode, verifyEmailCode };
export default email;
